
document.addEventListener("DOMContentLoaded", function () {
  const productsArray = localStorage.getItem("wishlist");

  if (productsArray && JSON.parse(productsArray).length > 0) {
    getData(JSON.parse(productsArray));
  } else {
    document.querySelector(".empty").style.display = "block";
  }
});

async function getData(array) {
  const formatter = Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

  for (let i = 0; i < array.length; i++) {
    const element = array[i];

    await fetch(window.Shopify.routes.root + `products/${element}.js`)
      .then((response) => response.json())
      .then((product) => {
        const { handle, title, price, media, url, compare_at_price_min } =
          product;
        const priceFormatted = formatter.format(price / 100);

        const image = media.filter((type) => type.media_type === "image");

        const listPriceHTML =
          compare_at_price_min > price
            ? `<p class="list-price text-[#999999] line-through text-sm">${formatter.format(
                compare_at_price_min / 100
              )}</p>`
            : "";

        const discountTag = Math.floor((((price / 100) * 100) / (compare_at_price_min / 100) - 100) * -1);
        // Parcela mínima de R$100 (10000 centavos), em até 6x
        const installmentsCount = Math.min(6, Math.max(1, Math.floor(price / 10000)));
        const installments = formatter.format(Math.ceil(price / installmentsCount) / 100);


        const item = document.createElement("li");
        item.classList.add("relative", "max-w-[310px]")
        item.innerHTML = `
<div class="wrapper-shelf relative">
  <div class="wishlist absolute right-2 top-2 z-[1]">
    <button
      class="flex items-center justify-center w-9 h-9 data-[wishlist=true]:bg-white data-[wishlist=true]:rounded-full"
      aria-label="Adicionar a Lista de desejos"
      onclick="handleStoreWishList('${handle}', this)"
      data-wishlist="true"
    >
    ${svg}
    </button>
  </div>
  <div class="pdp_img relative">
    <a class="image-wrapper" href="${url}">
       <img src="${
                  image[0].src
                }" width="427" height="650" alt="${title}" class="rounded-tl-lg rounded-tr-lg w-full max-w-48 max-h-48 mx-auto">
    </a>
    
    </div>
  </div>
  <a class="pdp-info-box flex flex-col gap-1 tablet:mt-4 pt-3" href="${url}">
    <h3 class="title-product font-bold text-base text-primary h-[48px] text-ellipsis line-clamp-2 ">
    ${title}
    </h3>
    <div class="shelf-price flex items-center gap-2 flex-wrap min-h-[28px]">
      ${listPriceHTML}
      <p class="best-price text-[#52AE32] font-bold text-base"> ${priceFormatted}</p>
    </div>
    <p class="text-[#999999] text-sm">ou ${installmentsCount}x de ${installments} sem juros</p>
  </a>
</div>

          `;

        document.querySelector(".wrapper-wishlist").appendChild(item);
      });
  }
}

const svg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.5091 5.97426L12 6.49118L11.4908 5.97418C10.5625 5.03112 9.29461 4.50006 7.97132 4.50006C6.64804 4.50006 5.38012 5.03112 4.45182 5.97418V5.97418C2.51606 7.96343 2.51606 11.1323 4.45182 13.1216L9.84447 18.5972C10.413 19.1748 11.1896 19.5 12 19.5C12.8105 19.5 13.587 19.1748 14.1556 18.5972L19.5482 13.1217C21.4839 11.1324 21.4839 7.96353 19.5482 5.97427V5.97427C18.6199 5.03118 17.3519 4.5001 16.0286 4.50009C14.7053 4.50009 13.4374 5.03117 12.5091 5.97426Z" stroke="#323232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  `;
